
import { Options, Vue } from "vue-class-component";
import RgbaToHex from "./components/RgbaToHex.vue";

@Options({
  components: {
    RgbaToHex,
  },
})
export default class App extends Vue {
  backgroundColor = "";
  colorCalculated = "";
  hex = "";

  calcRgba(color: any) {
    this.backgroundColor = color.color;
    this.colorCalculated = color.color;
    this.hex = color.hex;
  }
}
